import React from "react";
import PropTypes from "prop-types";
import "./ShinyLoader.scss";

const ShinyLoader = ({ width, height, customClass, key }) => {
    return (
        <div
            className={`shiny__line ${customClass ? customClass : ""}`}
            style={{ width, height }}
            key={key}></div>
    );
};

ShinyLoader.default = {
    width: "20px",
    height: "10px",
};

ShinyLoader.propTypes = {
    height: PropTypes.string,
    width: PropTypes.string,
    customClass: PropTypes.string,
};

export default ShinyLoader;
